/**
 *  Enum used to control the different types of bullet list
 */
// eslint-disable-next-line etc/no-const-enum
export var BulletListType;
(function (BulletListType) {
    /**
     * Minimum value of the enum
     */
    BulletListType[BulletListType["Min"] = 1] = "Min";
    /**
     * Bullet triggered by *
     */
    BulletListType[BulletListType["Disc"] = 1] = "Disc";
    /**
     * Bullet triggered by -
     */
    BulletListType[BulletListType["Dash"] = 2] = "Dash";
    /**
     * Bullet triggered by --
     */
    BulletListType[BulletListType["Square"] = 3] = "Square";
    /**
     * Bullet triggered by >
     */
    BulletListType[BulletListType["ShortArrow"] = 4] = "ShortArrow";
    /**
     * Bullet triggered by ->
     */
    BulletListType[BulletListType["LongArrow"] = 5] = "LongArrow";
    /**
     * Bullet triggered by =>
     */
    BulletListType[BulletListType["UnfilledArrow"] = 6] = "UnfilledArrow";
    /**
     * Bullet triggered by —
     */
    BulletListType[BulletListType["Hyphen"] = 7] = "Hyphen";
    /**
     * Bullet triggered by -->
     */
    BulletListType[BulletListType["DoubleLongArrow"] = 8] = "DoubleLongArrow";
    /**
     * Bullet type circle
     */
    BulletListType[BulletListType["Circle"] = 9] = "Circle";
    /**
     * Maximum value of the enum
     */
    BulletListType[BulletListType["Max"] = 9] = "Max";
})(BulletListType || (BulletListType = {}));
//# sourceMappingURL=BulletListType.js.map